<template>
    <v-expansion-panel-header
        hide-actions
        class="pr-2"
    >
        <template v-slot:default="{ open }">
            <v-row
                align="center"
                justify="end"
                no-gutters
            >
                    <span class="subtitle-2 font-weight-medium">
                        {{ $t(panel.groupName) }}
                    </span>
                <v-spacer></v-spacer>
                <v-tooltip v-if="panel.panelIcon" bottom>
                    <template v-slot:activator="{ on: tooltipOn }">
                        <v-btn
                            v-on="tooltipOn"
                            icon
                            @click.stop="$emit('addNew', panel.groupKey)"
                        >
                            <icon
                                :icon="panel.panelIcon.icon"
                                :small="panel.panelIcon.small"
                                v-on="tooltipOn"
                                color="primary"
                            />
                        </v-btn>
                    </template>
                    <span>{{ panel.panelIcon.tooltip }}</span>
                </v-tooltip>
                <icon :icon="open ? 'ChevronUp' : 'ChevronDown'"/>
            </v-row>
        </template>
    </v-expansion-panel-header>

</template>

<script>

export default {
    name: "SidebarPanelHeader",
    props: {
        panel: {
            type: Object,
            required: true,
        }
    },
}

</script>

<style scoped lang="scss">

</style>